import React from 'react';
import './CustomServerGrid.css';

const CustomServerGrid = ({
  maxGuesses = 5,
  wordLength = 5,
  guesses = [],
  currentGuess = '',
  currentRow = 0,
  isTypingEnabled = true,
}) => {
  const rows = Array.from({ length: Math.max(1, Number(maxGuesses) || 1) }, (_, index) => {
    const committed = guesses[index] || null;
    const committedWord = String(committed?.word || '').toUpperCase();
    const committedStatuses = Array.isArray(committed?.letterStatuses)
      ? committed.letterStatuses
      : [];

    return {
      committedWord,
      committedStatuses,
      isActive: !committed && index === currentRow,
    };
  });

  return (
    <div className="custom-server-grid" role="grid" aria-label="Custom game grid">
      {rows.map((row, rowIndex) => (
        <div
          key={rowIndex}
          className="custom-server-grid__row"
          style={{ gridTemplateColumns: `repeat(${Math.max(1, wordLength)}, 1fr)` }}
        >
          {Array.from({ length: Math.max(1, Number(wordLength) || 1) }).map((_, colIndex) => {
            const committedLetter = row.committedWord[colIndex] || '';
            const activeLetter =
              row.isActive && isTypingEnabled ? String(currentGuess || '')[colIndex] || '' : '';
            const letter = committedLetter || activeLetter;
            const status =
              committedLetter && row.committedStatuses[colIndex]
                ? String(row.committedStatuses[colIndex]).toLowerCase()
                : '';
            const showCaret =
              row.isActive &&
              isTypingEnabled &&
              !committedLetter &&
              !activeLetter &&
              colIndex === String(currentGuess || '').length;
            const shouldFlip = Boolean(committedLetter && status);
            const cellClassName = ['cell', status, shouldFlip ? 'flip' : ''].filter(Boolean).join(' ');

            return (
              <div key={colIndex} className={cellClassName}>
                {letter || (showCaret ? '_' : '')}
              </div>
            );
          })}
        </div>
      ))}
    </div>
  );
};

export default CustomServerGrid;
